<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Transfer {{ user.name }} to other Manager</p>
                <button class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <manager-select></manager-select>
                <div class="notification">
                    <strong>Please add some text here regarding the user transfer!</strong>
                    adipiscing elit lorem ipsum dolor. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum <a>felis venenatis</a> efficitur. Sit amet,
                    consectetur adipiscing elit
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-danger" :class="{'is-loading' : isLoading}" @click.prevent="transferUser">Transfer User</button>
                <button class="button" @click.prevent="closeModal">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import apiUsers from '../../../../api/apiUsers'
    import ManagerSelect from './ManagerSelect'
    export default {
        props: ['user'],
        components: {
            ManagerSelect
        },
        data () {
            return {
                isLoading: false
            }
        },
        methods: {
            transferUser() {
                this.isLoading = true
                let userId = this.user.id
                let user = {
                    email: this.user.email,
                    name: this.user.name,
                    role: this.user.role,
                    manager_id: this.$store.getters.getUserTransferManager.id
                }
                apiUsers
                    .userUpdateRequest(userId, user)
                    .then((response) => {
                        this.$store.dispatch('setUserTransferManager', null)
                        this.$store.dispatch('setUserTransferModalStatus', false)
                        this.isLoading = false
                        location.reload()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            closeModal() {
                this.$store.dispatch('setUserTransferModalStatus', false)
            }
        },
        computed: {
            isActive() {
                return this.$store.getters.getUserTransferModalStatus
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/Transfer/TransferUserModal.vue